module.exports = __webpack_public_path__ + "static/media/logo_LogIn.65be9eea.PNG";